import { render, staticRenderFns } from "./customer-detail-info.vue?vue&type=template&id=6867baaa&scoped=true"
import script from "./customer-detail-info.vue?vue&type=script&lang=js"
export * from "./customer-detail-info.vue?vue&type=script&lang=js"
import style0 from "./customer-detail-info.vue?vue&type=style&index=0&id=6867baaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867baaa",
  null
  
)

export default component.exports